import { LogRepository } from "@domain/repositories/LogRepository";
import UseCase from "@domain/UseCase";
import { Log } from "@domain/models/Log";
import { User } from "@domain/models/User";

type Input = User["id"];

type Output = Promise<Log[]>;

export class GetUserLogsUseCase implements UseCase<Input, Output> {
  constructor(private readonly logRepository: LogRepository) {}

  async execute(userId: Input) {
    return this.logRepository.getUserLogs(userId);
  }
}
